<template>
  <div>
    <b-modal
      title="更新下次互助名單"
      size="lg"
      centered
      hide-footer
      header-class="head-modal"
      v-model="modalShow"
    >
      <b-form-group label-cols="auto" label-cols-lg="auto" label="下次互助名單">
        <b-form-checkbox switch size="lg" value=1 unchecked-value=0 v-model.number="data.help_check"></b-form-checkbox>
      </b-form-group>

      <div class="text-center mt-4">
        <b-button
          class="mr-2"
          variant="success"
          size="sm"
          @click="sumit()"
        >
          確定
        </b-button>
        <b-button
          variant="danger"
          size="sm"
          class="mr-4"
          @click="$emit('change', false)"
        >
          取消
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>

export default {
  name: 'UpdatePaymentModal',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false
    },
    data: {
      type: Object,
      required: false,
      default: () => {}
    },
  },
  data () {
    return {

    }
  },
  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('change', value);
      }
    },
  },
  mounted() {

  },
  methods: {
    // 匯出未繳費帳單
    sumit() {
      this.$emit('sumit');
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/components/modal/UpdateHelpCheckModal.vue